import { Box } from '@mui/material';
import { CustomButton, HorizontalForm } from '../../../common';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import AnalyticsIcon from '@mui/icons-material/Analytics';

const XnetAnalyzer = ({
  selectedFile,
  onFileUpload,
  onAnalyze,
  fileInputRef,
}) => {
  return (
    <HorizontalForm sx={{ alignItems: 'center' }}>
      
      <input
        type="file"
        accept=".txt"
        onChange={onFileUpload}
        style={{ display: 'none' }}
        ref={fileInputRef}
        id="xnetFileUpload"
      />
      
      <label htmlFor="xnetFileUpload">
        <CustomButton
          variant="base"
          component="span"
          buttonIcon={FileUploadIcon}
        >
          Seleccionar archivo XNET
        </CustomButton>
      </label>
      
      <Box
        sx={{
          fontSize: '15px',
          ml: 3,
          mt: 1,
        }}
      >
        {selectedFile ? selectedFile.name : 'Sin archivos seleccionados'}
      </Box>
      
      <CustomButton
        variant="base"
        sx={{ml: 2}}
        onClick={onAnalyze}
        buttonIcon={AnalyticsIcon}
        disabled={!selectedFile}
      >
        Analizar
      </CustomButton>
    </HorizontalForm>
  );
};

export default XnetAnalyzer;
